// extracted by mini-css-extract-plugin
module.exports = {"editor-errors-popover":"EditorErrors_editor-errors-popover__3RGHf","error-group":"EditorErrors_error-group__j3rYm","error-group-list":"EditorErrors_error-group-list__QwDIq"};